import { Component, OnInit } from '@angular/core';
import { CmsPageService } from '../../services/cms.page.service';
import { CmsPageType } from '../../models/cms.pages/cms.pages.models';
import { GetCmsPageDto } from '../../models/cms.pages/cms.pages.models';

@Component({
    selector: 'competitor-help',
    template: require('./competitor.help.component.html')
})
export class CompetitorHelpComponent implements OnInit {
    pageContent: string;

    constructor(private readonly cmsPageService: CmsPageService) {

    }

    ngOnInit() {
        this.cmsPageService.getByType(CmsPageType.CompetitorHelp).subscribe((result: GetCmsPageDto) => {
            this.pageContent = result.content;
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/competitor.help.component.ts